import {
    blockConfigAggregator,
    buttonsConfigAggregator,
    buttonItemConfigAggregator,
    columnConfigAggregator,
    columnGroupConfigAggregator,
    columnLineConfigAggregator,
    headingConfigAggregator,
    productsConfigAggregator,
    imageConfigAggregator,
    rowConfigAggregator,
    tabItemConfigAggregator,
    tabsConfigAggregator,
    textConfigAggregator,
    htmlConfigAggregator,
    dividerConfigAggregator,
    videoConfigAggregator,
    mapConfigAggregator,
    bannerConfigAggregator,
    sliderConfigAggregator,
    dynamicBlockConfigAggregator,
    PageBuilderRow,
    PageBuilderColumnGroup,
    PageBuilderColumnLine,
    PageBuilderColumn,
    PageBuilderImage,
    PageBuilderHeading,
    PageBuilderText,
    PageBuilderTabs,
    PageBuilderButtons,
    PageBuilderButtonItem,
    PageBuilderBlock,
    PageBuilderProducts,
    PageBuilderHtml,
    PageBuilderDivider,
    PageBuilderVideo,
    PageBuilderMap,
    PageBuilderBanner,
    PageBuilderSlider,
    PageBuilderTabItem,
    PageBuilderDynamicBlock,
} from '../components';
import type { ContentType, Aggregator, ContentTypesConfig } from '../types/pbTypes';

/**
 * Content types configuration
 */
export const contentTypesConfig: ContentTypesConfig = {
    row: {
        configAggregator: rowConfigAggregator,
        component: PageBuilderRow,
    },
    'column-group': {
        configAggregator: columnGroupConfigAggregator,
        component: PageBuilderColumnGroup,
    },
    'column-line': {
        configAggregator: columnLineConfigAggregator,
        component: PageBuilderColumnLine,
    },
    column: {
        configAggregator: columnConfigAggregator,
        component: PageBuilderColumn,
    },
    image: {
        configAggregator: imageConfigAggregator,
        component: PageBuilderImage,
    },
    heading: {
        configAggregator: headingConfigAggregator,
        component: PageBuilderHeading,
    },
    text: {
        configAggregator: textConfigAggregator,
        component: PageBuilderText,
    },
    tabs: {
        configAggregator: tabsConfigAggregator,
        component: PageBuilderTabs,
    },
    'tab-item': {
        configAggregator: tabItemConfigAggregator,
        component: PageBuilderTabItem,
    },
    buttons: {
        configAggregator: buttonsConfigAggregator,
        component: PageBuilderButtons,
    },
    'button-item': {
        configAggregator: buttonItemConfigAggregator,
        component: PageBuilderButtonItem,
    },
    block: {
        configAggregator: blockConfigAggregator,
        component: PageBuilderBlock,
    },
    dynamic_block: {
        configAggregator: dynamicBlockConfigAggregator,
        component: PageBuilderDynamicBlock,
    },
    products: {
        configAggregator: productsConfigAggregator,
        component: PageBuilderProducts,
    },
    html: {
        configAggregator: htmlConfigAggregator,
        component: PageBuilderHtml,
    },
    divider: {
        configAggregator: dividerConfigAggregator,
        component: PageBuilderDivider,
    },
    video: {
        configAggregator: videoConfigAggregator,
        component: PageBuilderVideo,
    },
    map: {
        configAggregator: mapConfigAggregator,
        component: PageBuilderMap,
    },
    banner: {
        configAggregator: bannerConfigAggregator,
        component: PageBuilderBanner,
    },
    slider: {
        configAggregator: sliderConfigAggregator,
        component: PageBuilderSlider,
    },
    slide: {
        configAggregator: bannerConfigAggregator,
        component: PageBuilderBanner,
    },
};

/**
 * Get the content type config
 * @param contentType
 */
export function getContentTypeConfig(contentType: ContentType): Aggregator | null {
    switch (contentType) {
        case 'row':
            return contentTypesConfig['row'];

        case 'column-group':
            return contentTypesConfig['column-group'];

        case 'column-line':
            return contentTypesConfig['column-line'];

        case 'column':
            return contentTypesConfig['column'];

        case 'image':
            return contentTypesConfig['image'];

        case 'heading':
            return contentTypesConfig['heading'];

        case 'text':
            return contentTypesConfig['text'];

        case 'tabs':
            return contentTypesConfig['tabs'];

        case 'tab-item':
            return contentTypesConfig['tab-item'];

        case 'buttons':
            return contentTypesConfig['buttons'];

        case 'button-item':
            return contentTypesConfig['button-item'];

        case 'block':
            return contentTypesConfig['block'];

        case 'dynamic_block':
            return contentTypesConfig['dynamic_block'];

        case 'products':
            return contentTypesConfig['products'];

        case 'html':
            return contentTypesConfig['html'];

        case 'divider':
            return contentTypesConfig['divider'];

        case 'video':
            return contentTypesConfig['video'];

        case 'map':
            return contentTypesConfig['map'];

        case 'banner':
            return contentTypesConfig['banner'];

        case 'slider':
            return contentTypesConfig['slider'];

        case 'slide':
            return contentTypesConfig['slide'];

        default:
            return null;
    }
}
